import { render, staticRenderFns } from "./FormDetailTriggers.vue?vue&type=template&id=1b54ac84&scoped=true&"
import script from "./FormDetailTriggers.vue?vue&type=script&lang=js&"
export * from "./FormDetailTriggers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54ac84",
  null
  
)

export default component.exports